import LoaderView from '../../../components/Loader/loader'
import { Typography } from '@lightbeamai/design-system'
import React from 'react'
import { Link } from 'react-router-dom'

import './rowItemWidget.less'

type WidgetData = {
  key: string
  value?: string | number
  link?: string
}[]

interface IProps {
  title: string
  widgetData: WidgetData
  showLoader?: boolean
}

const RowItemWidget = ({ title, widgetData, showLoader = false }: IProps) => {
  return (
    <div className="row-item-widget lb-widget-card xs-p-16">
      <Typography className="font-600 widget-header xs-mb-16">{title}</Typography>
      {widgetData.map((item, index) =>
        item.link ? (
          <Link
            className="row-item jc-space-between align-center xs-py-4 xs-px-8"
            key={index}
            to={item.link}
          >
            <Typography variant={'baseMinus2'} dangerouslySetInnerHTML={{ __html: item.key }} />
            <Typography variant={'basePlus2'} className="font-700">
              {item.value}
            </Typography>
          </Link>
        ) : (
          <div className="row-item jc-space-between align-center xs-py-4 xs-px-8" key={index}>
            <Typography variant={'baseMinus2'} dangerouslySetInnerHTML={{ __html: item.key }} />
            <Typography variant={'basePlus2'} className="font-700">
              {item.value}
            </Typography>
          </div>
        )
      )}
      <LoaderView showLoader={showLoader} size="small" />
    </div>
  )
}

export default RowItemWidget
